"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "report-container"
  }, [_c("div", {
    staticClass: "report-header"
  }, [_c("img", {
    staticClass: "report-bg",
    attrs: {
      src: require("@/assets/images/report/bg.png"),
      alt: ""
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "sub-title"
  }, [_vm._v("基础版风控报告")]), _vm._v(" "), _vm.seqNoLines.length || _vm.data.seqNo ? _c("div", {
    staticClass: "report-info"
  }, [_vm._l(_vm.seqNoLines, function (item) {
    return _c("div", {
      key: item.key,
      staticClass: "report-info-item"
    }, [_c("div", [_vm._v(_vm._s(item.label) + "流水号")]), _vm._v(" "), _c("div", [_vm._v(_vm._s(item.value))])]);
  }), _vm._v(" "), !_vm.seqNoLines.length && _vm.data.seqNo ? _c("div", {
    staticClass: "report-info-item"
  }, [_c("div", [_vm._v("交易流水号")]), _vm._v(" "), _c("div", [_vm._v(_vm._s(_vm.data.seqNo))])]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "report-body"
  }, [_c("div", {
    staticClass: "report-body-item"
  }, [_vm._m(0), _vm._v(" "), _c("div", {
    staticClass: "report-body-content"
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("div", {
    staticClass: "base-item"
  }, [_c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n                个人信息\n              ")]), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("div", {
    staticClass: "info_item"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("姓名")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(" " + _vm._s(_vm.member["real_name"]))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("性别")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.member.gender))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("年龄")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.member.age) + "岁")])]), _vm._v(" "), _c("div", {
    staticClass: "info_item"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("身份证号")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.member.card_code))])])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("div", {
    staticClass: "base-item"
  }, [_c("div", {
    staticClass: "base-item-title mb-[8px]"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n                运营商风险\n              ")]), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("手机号")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.member.mobile))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("归属运营商")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.operatorDisplay))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("是否携号转网")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.xhzwDisplay))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("运营商实名")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.operatorRealDisplay))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("手机号在网时长")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.onlineTimeDisplay) + "\n                  ")])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold info-label"
  }, [_vm._v("运营商三要素验证")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm.data.three_info && _vm.data.three_info.state == 1 ? _c("div", {
    staticClass: "normaltag"
  }, [_vm._v("三要素一致")]) : _vm.data.three_info && _vm.data.three_info.state == 2 ? _c("div", {
    staticClass: "normaltag wrongtag"
  }, [_vm._v("三要素不一致")]) : _c("div", {
    staticClass: "normaltag wrongtag"
  }, [_vm._v("暂无数据")])])])])])])], 1)], 1)]), _vm._v(" "), _c("div", {
    staticClass: "report-body-item"
  }, [_vm._m(1), _vm._v(" "), _c("div", {
    staticClass: "report-body-content"
  }, [_c("div", {
    staticClass: "risk-items-container"
  }, [_c("div", {
    staticClass: "risk-item",
    class: _vm.data.is_black == true ? "risk-item1" : ""
  }, [_c("div", {
    staticClass: "risk-item-title"
  }, [_c("img", {
    staticClass: "risk-item-icon",
    attrs: {
      src: require("@/assets/images/report/risk-icon7.png"),
      alt: ""
    }
  }), _vm._v(" "), _vm.data.is_black == true ? _c("div", {
    staticClass: "risk-item-tag risk-item-tag1"
  }, [_vm._v("命中")]) : _c("div", {
    staticClass: "risk-item-tag"
  }, [_vm._v("未命中")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-content"
  }, [_vm._v("金融黑名单")]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-desc"
  }, [_vm._v("应诺尔金融黑名单（证件/手机维度命中）")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item",
    class: _vm.data.is_wdhmd == true ? "risk-item1" : ""
  }, [_c("div", {
    staticClass: "risk-item-title"
  }, [_c("img", {
    staticClass: "risk-item-icon",
    attrs: {
      src: require("@/assets/images/report/risk-icon1.png"),
      alt: ""
    }
  }), _vm._v(" "), _vm.data.is_wdhmd == true ? _c("div", {
    staticClass: "risk-item-tag risk-item-tag1"
  }, [_vm._v("命中")]) : _c("div", {
    staticClass: "risk-item-tag"
  }, [_vm._v("未命中")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-content"
  }, [_vm._v("网贷黑名单")]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-desc"
  }, [_vm._v("法院公开信息中网贷相关标记（当前渠道多数无独立字段）")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item",
    class: _vm.data.now_yq == true ? "risk-item1" : ""
  }, [_c("div", {
    staticClass: "risk-item-title"
  }, [_c("img", {
    staticClass: "risk-item-icon",
    attrs: {
      src: require("@/assets/images/report/risk-icon2.png"),
      alt: ""
    }
  }), _vm._v(" "), _vm.data.now_yq == true ? _c("div", {
    staticClass: "risk-item-tag risk-item-tag1"
  }, [_vm._v("命中")]) : _c("div", {
    staticClass: "risk-item-tag"
  }, [_vm._v("未命中")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-content"
  }, [_vm._v("当前存在逾期")]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-desc"
  }, [_vm._v("探针C：result_code=逾期未还款")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item",
    class: _vm.data.thirty_yq == true ? "risk-item1" : ""
  }, [_c("div", {
    staticClass: "risk-item-title"
  }, [_c("img", {
    staticClass: "risk-item-icon",
    attrs: {
      src: require("@/assets/images/report/risk-icon3.png"),
      alt: ""
    }
  }), _vm._v(" "), _vm.data.thirty_yq == true ? _c("div", {
    staticClass: "risk-item-tag risk-item-tag1"
  }, [_vm._v("命中")]) : _c("div", {
    staticClass: "risk-item-tag"
  }, [_vm._v("未命中")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-content"
  }, [_vm._v("当月逾期")]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-desc"
  }, [_vm._v("最近逾期时间落在当月")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item",
    class: _vm.data.is_shixin == true ? "risk-item1" : ""
  }, [_c("div", {
    staticClass: "risk-item-title"
  }, [_c("img", {
    staticClass: "risk-item-icon",
    attrs: {
      src: require("@/assets/images/report/risk-icon4.png"),
      alt: ""
    }
  }), _vm._v(" "), _vm.data.is_shixin == true ? _c("div", {
    staticClass: "risk-item-tag risk-item-tag1"
  }, [_vm._v("命中")]) : _c("div", {
    staticClass: "risk-item-tag"
  }, [_vm._v("未命中")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-content"
  }, [_vm._v("失信行为")]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-desc"
  }, [_vm._v("表明用户存在失信行为风险")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item",
    class: _vm.data.is_xiangao == true ? "risk-item1" : ""
  }, [_c("div", {
    staticClass: "risk-item-title"
  }, [_c("img", {
    staticClass: "risk-item-icon",
    attrs: {
      src: require("@/assets/images/report/risk-icon5.png"),
      alt: ""
    }
  }), _vm._v(" "), _vm.data.is_xiangao == true ? _c("div", {
    staticClass: "risk-item-tag risk-item-tag1"
  }, [_vm._v("命中")]) : _c("div", {
    staticClass: "risk-item-tag"
  }, [_vm._v("未命中")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-content"
  }, [_vm._v("限制高消费")]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-desc"
  }, [_vm._v("表明用户存在限制高消费风险")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item",
    class: _vm.data.is_sifa == true ? "risk-item1" : ""
  }, [_c("div", {
    staticClass: "risk-item-title"
  }, [_c("img", {
    staticClass: "risk-item-icon",
    attrs: {
      src: require("@/assets/images/report/risk-icon6.png"),
      alt: ""
    }
  }), _vm._v(" "), _vm.data.is_sifa == true ? _c("div", {
    staticClass: "risk-item-tag risk-item-tag1"
  }, [_vm._v("命中")]) : _c("div", {
    staticClass: "risk-item-tag"
  }, [_vm._v("未命中")])]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-content"
  }, [_vm._v("司法风险")]), _vm._v(" "), _c("div", {
    staticClass: "risk-item-desc"
  }, [_vm._v("表明用户存在一年内司法风险")])])])]), _vm._v(" "), _vm.hasBlackDetail || _vm.data.channel_errors && _vm.data.channel_errors.blacklist ? _c("div", {
    staticClass: "report-body-content",
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c("div", {
    staticClass: "base-item"
  }, [_c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            金融黑名单明细\n            "), _vm.data.seqNos && _vm.data.seqNos.blacklist ? _c("span", {
    staticStyle: {
      "margin-left": "12px",
      "font-size": "14px",
      "font-weight": "400",
      color: "#888"
    }
  }, [_vm._v("\n              流水号 " + _vm._s(_vm.data.seqNos.blacklist) + "\n            ")]) : _vm._e()]), _vm._v(" "), _vm.data.channel_errors && _vm.data.channel_errors.blacklist ? _c("div", {
    staticStyle: {
      color: "#E6A23C",
      padding: "8px 0"
    }
  }, [_vm._v("\n            黑名单通道异常：" + _vm._s(_vm.data.channel_errors.blacklist) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm.hasBlackDetail ? _c("div", {
    staticClass: "base-item-content black-detail-content"
  }, [_c("el-row", {
    attrs: {
      gutter: 40
    }
  }, _vm._l(_vm.blackDetailPanels, function (side) {
    return _c("el-col", {
      key: side.key,
      attrs: {
        span: 12
      }
    }, [_c("div", {
      staticClass: "black-detail-side-title"
    }, [_vm._v(_vm._s(side.title))]), _vm._v(" "), _vm._l(side.rows, function (row) {
      return _c("div", {
        key: row.label,
        staticClass: "info_item1"
      }, [_c("div", {
        staticClass: "font-semibold info-label"
      }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c("div", {
        staticClass: "info-num",
        class: row.tone
      }, [_vm._v(_vm._s(row.value))])]);
    })], 2);
  }), 1)], 1) : !(_vm.data.channel_errors && _vm.data.channel_errors.blacklist) ? _c("div", {
    staticStyle: {
      "text-align": "center",
      padding: "24px 0",
      color: "#909399"
    }
  }, [_vm._v("\n            未命中金融黑名单\n          ")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "report-body-item"
  }, [_c("div", {
    staticClass: "report-body-title"
  }, [_c("img", {
    staticClass: "report-title-icon",
    attrs: {
      src: require("@/assets/images/report/title-icon.png"),
      alt: ""
    }
  }), _vm._v("\n        履约探查\n        "), _vm.data.seqNos && _vm.data.seqNos.tzc ? _c("span", {
    staticStyle: {
      "margin-left": "12px",
      "font-size": "14px",
      "font-weight": "400",
      color: "#888"
    }
  }, [_vm._v("流水号 " + _vm._s(_vm.data.seqNos.tzc))]) : _vm._e()]), _vm._v(" "), _vm.data.channel_errors && _vm.data.channel_errors.tzc ? _c("div", {
    staticStyle: {
      color: "#E6A23C",
      margin: "8px 0 16px"
    }
  }, [_vm._v("探针通道异常：" + _vm._s(_vm.data.channel_errors.tzc))]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "report-body-content"
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "base-item"
  }, [_c("div", {
    staticClass: "base-item-title mb-[8px]",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c("div", {
    staticClass: "flex"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n                  逾期信息\n                ")]), _vm._v(" "), _vm.tzcField("result_code") == 1 || _vm.tzcField("result_code") == "1" ? _c("img", {
    staticClass: "report-state-icon",
    attrs: {
      src: require("@/assets/images/report/yuqi-state1.png"),
      alt: ""
    }
  }) : _vm.tzcField("result_code") == 2 || _vm.tzcField("result_code") == "2" ? _c("img", {
    staticClass: "report-state-icon",
    attrs: {
      src: require("@/assets/images/report/yuqi-state2.png"),
      alt: ""
    }
  }) : _vm.tzcField("result_code") == 3 || _vm.tzcField("result_code") == "3" ? _c("img", {
    staticClass: "report-state-icon",
    attrs: {
      src: require("@/assets/images/report/yuqi-state3.png"),
      alt: ""
    }
  }) : _c("div", {
    staticClass: "normaltag"
  }, [_vm._v(_vm._s(_vm.resultCodeLabel))])]), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold"
  }, [_vm._v("履约状态")]), _vm._v(" "), _c("div", [_vm._v(_vm._s(_vm.resultCodeLabel))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1",
    staticStyle: {
      color: "#FF0000"
    }
  }, [_c("div", {
    staticClass: "font-semibold"
  }, [_vm._v("最近逾期时间")]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "#FF655C"
    }
  }, [_vm._v(_vm._s(_vm.tzcField("latest_overdue_time") || "暂无"))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold"
  }, [_vm._v("最长逾期天数")]), _vm._v(" "), _c("div", [_vm._v(_vm._s(_vm.tzcField("max_overdue_days") ? "".concat(_vm.tzcField("max_overdue_days"), "\u5929") : "暂无"))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold"
  }, [_vm._v("最大逾期金额")]), _vm._v(" "), _c("div", [_vm._v(_vm._s(_vm.tzcField("max_overdue_amt") ? "".concat(_vm.tzcField("max_overdue_amt"), "\u5143") : "暂无"))])])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "base-item"
  }, [_c("div", {
    staticClass: "base-item-title mb-[8px]"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n                履约信息\n              ")]), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold"
  }, [_vm._v("履约笔数")]), _vm._v(" "), _c("div", [_vm._v(_vm._s(_vm.tzcField("count_performance") ? "".concat(_vm.tzcField("count_performance"), "\u7B14") : "暂无"))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold"
  }, [_vm._v("最近履约时间")]), _vm._v(" "), _c("div", [_vm._v(_vm._s(_vm.tzcField("latest_performance_time") || "暂无"))])]), _vm._v(" "), _c("div", {
    staticClass: "info_item1"
  }, [_c("div", {
    staticClass: "font-semibold"
  }, [_vm._v("最大履约金额")]), _vm._v(" "), _c("div", [_vm._v(_vm._s(_vm.tzcField("max_performance_amt") ? "".concat(_vm.tzcField("max_performance_amt"), "\u5143") : "暂无"))])])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "base-item"
  }, [_c("div", {
    staticClass: "base-item-title mb-[8px]"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n                机构信息\n              ")]), _vm._v(" "), _c("div", {
    staticClass: "base-item-content chart-container"
  }, [_c("doughnutChart", {
    ref: "pieChart1",
    staticClass: "chart-wrapper",
    attrs: {
      option: _vm.jigoudata
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "chart-info"
  }, [_c("div", {
    staticClass: "chart-item"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v("\n                    当前逾期机构数:" + _vm._s(_vm.tzcField("currently_overdue") != null ? _vm.tzcField("currently_overdue") : "-") + "\n                  ")]), _vm._v(" "), _c("div", {
    staticClass: "chart-item"
  }, [_c("span", {
    staticClass: "dot",
    staticStyle: {
      "background-color": "#66B2FE"
    }
  }), _vm._v("\n                    当前履约机构数:" + _vm._s(_vm.tzcField("currently_performance") != null ? _vm.tzcField("currently_performance") : "-") + "\n                  ")]), _vm._v(" "), _c("div", {
    staticClass: "chart-item"
  }, [_c("span", {
    staticClass: "dot",
    staticStyle: {
      "background-color": "#FEC14D"
    }
  }), _vm._v("\n                    异常还款机构数:" + _vm._s(_vm.tzcField("acc_exc") != null ? _vm.tzcField("acc_exc") : "-") + "\n                  ")]), _vm._v(" "), _c("div", {
    staticClass: "chart-item"
  }, [_c("span", {
    staticClass: "dot",
    staticStyle: {
      "background-color": "#ACACAC"
    }
  }), _vm._v("\n                    睡眠机构数:" + _vm._s(_vm.tzcField("acc_sleep") != null ? _vm.tzcField("acc_sleep") : "-") + "\n                  ")])])], 1)])])], 1)], 1)]), _vm._v(" "), _c("div", {
    staticClass: "report-body-item"
  }, [_c("div", {
    staticClass: "report-body-title"
  }, [_c("img", {
    staticClass: "report-title-icon",
    attrs: {
      src: require("@/assets/images/report/title-icon.png"),
      alt: ""
    }
  }), _vm._v("\n        行为轨迹\n        "), _vm.data.seqNos && _vm.data.seqNos.unify ? _c("span", {
    staticStyle: {
      "margin-left": "12px",
      "font-size": "14px",
      "font-weight": "400",
      color: "#888"
    }
  }, [_vm._v("流水号 " + _vm._s(_vm.data.seqNos.unify))]) : _vm._e()]), _vm._v(" "), _vm.data.channel_errors && _vm.data.channel_errors.unify ? _c("div", {
    staticStyle: {
      color: "#E6A23C",
      margin: "8px 0 16px"
    }
  }, [_vm._v("雷达通道异常：" + _vm._s(_vm.data.channel_errors.unify))]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "report-body-content"
  }, [_c("div", {
    staticClass: "leida-item"
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 3
    }
  }, [_c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160001"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160001"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("申请准入分")])])]), _vm._v(" "), _c("el-col", {
    staticStyle: {
      "border-right": "2px solid #54C1FE"
    },
    attrs: {
      span: 3
    }
  }, [_c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160002"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160002"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("申请准入置信度")])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 3
    }
  }, [_c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170001"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170001"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("贷款行为分")])])]), _vm._v(" "), _c("el-col", {
    staticStyle: {
      "border-right": "2px solid #54C1FE"
    },
    attrs: {
      span: 3
    }
  }, [_c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170051"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170051"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("贷款行为置信度")])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 3
    }
  }, [_c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180001"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180001"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("网贷授信额度")])])]), _vm._v(" "), _c("el-col", {
    staticStyle: {
      "border-right": "2px solid #54C1FE"
    },
    attrs: {
      span: 3
    }
  }, [_c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180002"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180002"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("网贷额度置信度")])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 3
    }
  }, [_c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180012"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180012"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("消金额度置信度")])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 3
    }
  }, [_c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180011"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180011"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("消金建议授信额度")])])])], 1)], 1)]), _vm._v(" "), _c("div", {
    staticClass: "report-body-content mt-[60px] mb-[60px]"
  }, [_c("div", {
    staticClass: "base-item shenqing-item"
  }, [_vm._m(2), _vm._v(" "), _c("div", {
    staticClass: "base-item-content shenqing-item-content"
  }, [_c("div", {
    staticClass: "leida-chart"
  }, [_c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160003"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160003"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("申请命中机构数")])]), _vm._v(" "), _c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160004"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160004"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("申请命中消金类机构数")])]), _vm._v(" "), _c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160005"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160005"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("申请命中网络贷款类机构数")])])]), _vm._v(" "), _c("div", {
    staticClass: "leida-table"
  }, [_c("div", {
    staticClass: "leida-info",
    staticStyle: {
      background: "#D2E1FF"
    }
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("最近一次查询时间")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160007"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160007"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "leida-info",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("机构总查询次数")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160006"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160006"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("近1个月机构总查询笔数")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160008"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160008"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "leida-info",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("近3个月机构总查询笔数")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160009"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160009"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "leida-info"
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("近6个月机构总查询笔数")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "apply_report_detail", "A22160010"]) ? _vm.getRiskValue(["unify_info", "apply_report_detail", "A22160010"]) : "-"))])])])])])]), _vm._v(" "), _c("div", {
    staticClass: "report-body-content mb-[60px]"
  }, [_c("div", {
    staticClass: "base-item action-item",
    staticStyle: {
      "min-height": "240px"
    }
  }, [_vm._m(3), _vm._v(" "), _c("el-row", {
    staticStyle: {
      "margin-top": "36px",
      "padding-bottom": "20px"
    },
    attrs: {
      gutter: 40
    }
  }, [_c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "action-info"
  }, [_c("div", {
    staticClass: "action-icon"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/action-icon1.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "action-right"
  }, [_c("div", {
    staticClass: "action-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170052"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170052"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "action-label"
  }, [_vm._v("贷款已结清订单数")])])])]), _vm._v(" "), _c("el-col", {
    staticStyle: {
      "border-left": "2px solid #4B77D7"
    },
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "action-info"
  }, [_c("div", {
    staticClass: "action-icon"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/action-icon2.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "action-right"
  }, [_c("div", {
    staticClass: "action-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170053"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170053"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "action-label"
  }, [_vm._v("信用贷款时长")])])])]), _vm._v(" "), _c("el-col", {
    staticStyle: {
      "border-left": "2px solid #4B77D7"
    },
    attrs: {
      span: 5
    }
  }, [_c("div", {
    staticClass: "action-info"
  }, [_c("div", {
    staticClass: "action-icon"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/action-icon3.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "action-right"
  }, [_c("div", {
    staticClass: "action-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170054"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170054"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "action-label"
  }, [_vm._v("最近一次贷款放款时间")])])])]), _vm._v(" "), _c("el-col", {
    staticStyle: {
      "border-left": "2px solid #4B77D7"
    },
    attrs: {
      span: 5
    }
  }, [_c("div", {
    staticClass: "action-info"
  }, [_c("div", {
    staticClass: "action-icon"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/action-icon4.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "action-right"
  }, [_c("div", {
    staticClass: "action-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170050"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170050"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "action-label"
  }, [_vm._v("最近一次履约距今天数")])])])]), _vm._v(" "), _c("el-col", {
    staticStyle: {
      "border-left": "2px solid #4B77D7"
    },
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "action-info"
  }, [_c("div", {
    staticClass: "action-icon"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/action-icon5.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "action-right"
  }, [_c("div", {
    staticClass: "action-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170034"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170034"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "action-label"
  }, [_vm._v("正常还款订单数占总贷款总订单数占比")])])])])], 1)], 1)]), _vm._v(" "), _c("div", {
    staticClass: "report-body-content mb-[60px]",
    staticStyle: {
      display: "flex",
      "justify-content": "space-between"
    }
  }, [_c("div", {
    staticClass: "base-item yuqi12-item",
    staticStyle: {
      "min-width": "300px",
      "padding-bottom": "20px"
    }
  }, [_vm._m(4), _vm._v(" "), _c("div", {
    staticClass: "base-item-content yuqi12-item-content",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c("div", {
    staticClass: "yuqi12-info"
  }, [_c("div", {
    staticClass: "info-title"
  }, [_vm._v("逾期贷款笔数")]), _vm._v(" "), _c("div", {
    staticClass: "info-box"
  }, [_c("div", {
    staticClass: "info-box-item"
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("近6月")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170025"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170025"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "info-box-item"
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("近12月")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170026"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170026"]) : "-"))])])])]), _vm._v(" "), _c("div", {
    staticClass: "yuqi12-info"
  }, [_c("div", {
    staticClass: "info-title"
  }, [_vm._v("逾期贷款笔数")]), _vm._v(" "), _c("div", {
    staticClass: "info-box"
  }, [_c("div", {
    staticClass: "info-box-item"
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("近6月")]), _vm._v(" "), _c("div", {
    staticClass: "info-num",
    staticStyle: {
      color: "#73BFBC"
    }
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170028"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170028"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "info-box-item"
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("近12月")]), _vm._v(" "), _c("div", {
    staticClass: "info-num",
    staticStyle: {
      color: "#73BFBC"
    }
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170029"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170029"]) : "-"))])])])]), _vm._v(" "), _c("div", {
    staticClass: "yuqi12-info1"
  }, [_c("div", {
    staticClass: "info-title"
  }, [_vm._v("逾期金额")]), _vm._v(" "), _c("div", {
    staticClass: "info-box"
  }, [_c("div", {
    staticClass: "info-box-item"
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("近6月")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue1(["unify_info", "behavior_report_detail", "B22170031"]) ? _vm.getRiskValue1(["unify_info", "behavior_report_detail", "B22170031"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "info-box-item"
  }, [_c("div", {
    staticClass: "info-label"
  }, [_vm._v("近12月")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue1(["unify_info", "behavior_report_detail", "B22170032"]) ? _vm.getRiskValue1(["unify_info", "behavior_report_detail", "B22170032"]) : "-"))])])])])])]), _vm._v(" "), _c("div", {
    staticClass: "base-item yuqi12-item",
    staticStyle: {
      flex: "1"
    }
  }, [_vm._m(5), _vm._v(" "), _c("div", {
    staticClass: "base-item-content yuqi12-item-content"
  }, [_c("div", {
    staticClass: "yuqi12-table"
  }, [_vm._m(6), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("失败扣款笔数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170035"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170035"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170036"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170036"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170037"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170037"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170038"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170038"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("履约贷款次数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170045"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170045"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170046"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170046"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170047"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170047"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170048"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170048"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("履约贷款总金额")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170040"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170040"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170041"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170041"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170042"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170042"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170043"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170043"]) : "-"))])])])])])]), _vm._v(" "), _c("div", {
    staticClass: "report-body-content mb-[60px]"
  }, [_c("div", {
    staticClass: "base-item daikan-item"
  }, [_vm._m(7), _vm._v(" "), _c("div", {
    staticClass: "base-item-content daikan-item-content"
  }, [_c("div", {
    staticClass: "common-table"
  }, [_vm._m(8), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("贷款笔数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170002"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170002"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170003"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170003"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170004"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170004"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170005"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170005"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("贷款总金额")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170007"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170007"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170008"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170008"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170009"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170009"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170010"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170010"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("贷款机构数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170016"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170016"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170017"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170017"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170018"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170018"]) : "-"))]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170019"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170019"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("消金类贷款机构数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170021"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170021"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("网贷类贷款机构数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170023"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170023"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("贷款金额1k及以下的笔数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170012"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170012"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("贷款金额1k-3k的笔数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170013"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170013"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("贷款金额3k-10k的笔数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170014"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170014"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "table-row"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("贷款金额1w以上的笔数")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("/")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170015"]) ? _vm.getRiskValue(["unify_info", "behavior_report_detail", "B22170015"]) : "-"))])])])])])]), _vm._v(" "), _c("div", {
    staticClass: "report-body-content mt-[60px] mb-[60px]"
  }, [_c("div", {
    staticClass: "base-item xinyong-item"
  }, [_vm._m(9), _vm._v(" "), _c("div", {
    staticClass: "base-item-content xinyong-item-content"
  }, [_c("div", {
    staticClass: "xinyong-chart"
  }, [_c("doughnutChart", {
    ref: "pieChart2",
    staticClass: "chart-wrapper",
    attrs: {
      option: _vm.xiaojindata
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "chart-info"
  }, [_c("div", {
    staticClass: "chart-item"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v("\n                  网络贷款机构数:" + _vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180003"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180003"]) : "-") + "\n                ")]), _vm._v(" "), _c("div", {
    staticClass: "chart-item"
  }, [_c("span", {
    staticClass: "dot",
    staticStyle: {
      "background-color": "#42D3C0"
    }
  }), _vm._v("\n                  网络贷款类产品数:" + _vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180004"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180004"]) : "-") + "\n                ")]), _vm._v(" "), _c("div", {
    staticClass: "chart-item"
  }, [_c("span", {
    staticClass: "dot",
    staticStyle: {
      "background-color": "#93B1FF"
    }
  }), _vm._v("\n                  消金贷款类机构数:" + _vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180007"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180007"]) : "-") + "\n                ")]), _vm._v(" "), _c("div", {
    staticClass: "chart-item"
  }, [_c("span", {
    staticClass: "dot",
    staticStyle: {
      "background-color": "#8AE4D3"
    }
  }), _vm._v("\n                  消金贷款类产品数:" + _vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180008"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180008"]) : "-") + "\n                ")])])], 1), _vm._v(" "), _c("div", {
    staticClass: "xinyong-table"
  }, [_c("div", {
    staticClass: "xinyong-info"
  }, [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180005"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180005"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "xinyong-info"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180006"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180006"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "xinyong-info"
  }, [_vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180009"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180009"]) : "-"))])]), _vm._v(" "), _c("div", {
    staticClass: "xinyong-info"
  }, [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.getRiskValue(["unify_info", "current_report_detail", "C22180010"]) ? _vm.getRiskValue(["unify_info", "current_report_detail", "C22180010"]) : "-"))])])])])])])]), _vm._v(" "), _c("div", {
    staticClass: "report-body-item"
  }, [_c("div", {
    staticClass: "report-body-title"
  }, [_c("img", {
    staticClass: "report-title-icon",
    attrs: {
      src: require("@/assets/images/report/title-icon.png"),
      alt: ""
    }
  }), _vm._v("\n        深度探查\n        "), _vm.data.seqNos && _vm.data.seqNos.court ? _c("span", {
    staticStyle: {
      "margin-left": "12px",
      "font-size": "14px",
      "font-weight": "400",
      color: "#888"
    }
  }, [_vm._v("流水号 " + _vm._s(_vm.data.seqNos.court))]) : _vm._e()]), _vm._v(" "), _vm.data.channel_errors && _vm.data.channel_errors.court ? _c("div", {
    staticStyle: {
      color: "#E6A23C",
      margin: "8px 0 16px"
    }
  }, [_vm._v("法院通道异常：" + _vm._s(_vm.data.channel_errors.court))]) : _vm.fayuanall == 0 ? _c("div", {
    staticStyle: {
      "text-align": "center",
      padding: "24px 0",
      color: "#909399"
    }
  }, [_vm._v(_vm._s(_vm.courtEmptyTip))]) : _vm._e(), _vm._v(" "), _vm.data.court_info && (_vm.data.court_info.has_case || _vm.courtStatRows.length) ? _c("div", {
    staticClass: "report-body-content court-summary-block",
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c("div", {
    staticClass: "base-item"
  }, [_c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            法院公开汇总\n            "), _c("span", {
    staticStyle: {
      "margin-left": "12px",
      "font-size": "14px",
      "font-weight": "400"
    },
    style: {
      color: _vm.courtHasCaseLabel === "有案" ? "#E6A23C" : "#67C23A"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.courtHasCaseLabel) + "\n            ")])]), _vm._v(" "), _vm.courtStatNumRows.length || _vm.courtStatTextRows.length ? _c("div", {
    staticClass: "base-item-content court-stat-content"
  }, [_vm.courtStatNumRows.length ? _c("div", {
    staticClass: "court-stat-nums"
  }, _vm._l(_vm.courtStatNumRows, function (row) {
    return _c("div", {
      key: row.key,
      staticClass: "info_item1"
    }, [_c("div", {
      staticClass: "font-semibold info-label"
    }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c("div", {
      staticClass: "info-num"
    }, [_vm._v(_vm._s(row.value))])]);
  }), 0) : _vm._e(), _vm._v(" "), _vm.courtStatTextRows.length ? _c("div", {
    staticClass: "court-dist-wrap"
  }, _vm._l(_vm.courtStatTextRows, function (row) {
    return _c("div", {
      key: row.key,
      staticClass: "info_item1 court-dist-row"
    }, [_c("div", {
      staticClass: "font-semibold info-label"
    }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c("div", {
      staticClass: "info-num"
    }, [_vm._v(_vm._s(row.value))])]);
  }), 0) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "report-body-content court-hit-block"
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "fayuan-item"
  }, [_c("div", {
    staticClass: "fayuan-info"
  }, [_c("div", {
    staticClass: "info-icon"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/fayuan-icon1.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "info-label"
  }, [_vm._v("命中总数")]), _vm._v(" "), _c("div", {
    staticClass: "info-num"
  }, [_vm._v(_vm._s(_vm.fayuanall))])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 20
    }
  }, [_c("div", {
    staticClass: "fayuan-item fayuan-left"
  }, _vm._l(_vm.fayuanHitCards, function (item) {
    return _c("div", {
      key: item.label,
      staticClass: "fayuan-info"
    }, [_c("div", {
      staticClass: "info-icon"
    }, [_c("img", {
      attrs: {
        src: item.iconSrc,
        alt: ""
      }
    })]), _vm._v(" "), _c("div", {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c("div", {
      staticClass: "fayuan-item-tag",
      class: {
        "fayuan-item-tag1": item.hit
      }
    }, [_vm._v("\n                  " + _vm._s(item.hit ? "命中" : "未命中") + "\n                ")])]);
  }), 0)])], 1)], 1), _vm._v(" "), _vm.isEnolfaxCourt && _vm.courtFlatList.length ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[60px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            法院案件明细\n            "), _vm.data.court_info && _vm.data.court_info.count != null ? _c("span", {
    staticStyle: {
      "margin-left": "12px",
      "font-size": "14px",
      "font-weight": "400",
      color: "#888"
    }
  }, [_vm._v("\n              案件数 " + _vm._s(_vm.data.court_info.count) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "14px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.courtFlatList,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "_typeLabel",
      label: "分类",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseNo",
      label: "案号",
      "min-width": "130"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseNoYs",
      label: "原审案号",
      "min-width": "110",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseNoHx",
      label: "后续案号",
      "min-width": "110",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseType",
      label: "案件类型",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "court",
      label: "经办法院",
      "min-width": "130"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "courtLevel",
      label: "法院层级",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "province",
      label: "所属地域",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "filingDate",
      label: "立案日",
      width: "100"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "closeDate",
      label: "结案日",
      width: "100"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "ajjzjd",
      label: "进展阶段",
      width: "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "pname",
      label: "当事人",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "n_ssdw",
      label: "诉讼地位",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "proposer",
      label: "对方当事人",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseCause",
      label: "案由",
      "min-width": "110"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "trialProcedure",
      label: "审理程序",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseState",
      label: "状态",
      width: "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.caseState == 1 ? _c("div", [_vm._v("已结")]) : scope.row.caseState == 0 ? _c("div", [_vm._v("在办")]) : _c("div", [_vm._v("-")])];
      }
    }], null, false, 1583507975)
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "execMoney",
      label: "标的金额",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.execMoney !== "" && scope.row.execMoney != null ? scope.row.execMoney : "-") + "\n                ")];
      }
    }], null, false, 2265288920)
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "moneyLevel",
      label: "标的等级",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "unnexeMoney",
      label: "未执行金额",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.unnexeMoney !== "" && scope.row.unnexeMoney != null ? scope.row.unnexeMoney : "-") + "\n                ")];
      }
    }], null, false, 2561903342)
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "pjVictory",
      label: "胜诉估计",
      width: "90"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "judgeResult",
      label: "裁判/结果",
      "min-width": "110"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "body",
      label: "概要",
      "min-width": "100"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "n_ajbs",
      label: "案件标识",
      width: "110",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), _vm.casesTreeFlat.length ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[40px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_vm._m(18), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "14px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.casesTreeFlat,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "category",
      label: "大类",
      width: "100"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "case_type",
      label: "类型",
      width: "100"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "c_ah",
      label: "案号",
      "min-width": "140"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "n_jbfy",
      label: "法院",
      "min-width": "140"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "d_larq",
      label: "立案日",
      width: "110"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "n_ssdw",
      label: "诉讼地位",
      width: "100"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "n_ajbs",
      label: "案件标识",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), !_vm.isEnolfaxCourt && _vm.fayuannum[0] != 0 ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[60px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_vm._m(19), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "16px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.zxggData,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "zxggId",
      label: "执行公告ID"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sortTimeString",
      label: "立案时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "pname",
      label: "被执行人姓名"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "idcardNo",
      label: "身份证号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "court",
      label: "执行法院名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseNo",
      label: "案号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseState",
      label: "案件状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.caseState == 1 ? _c("div", [_vm._v("案件结束")]) : scope.row.caseState == 0 ? _c("div", [_vm._v("执行中")]) : _c("div", [_vm._v("不明确")])];
      }
    }], null, false, 1992866180)
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "execMoney",
      label: "执行标的"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.execMoney) + "元\n                ")];
      }
    }], null, false, 109394453)
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "body",
      label: "内容概要"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "matchRatio",
      label: "匹配度",
      fixed: "right"
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), !_vm.isEnolfaxCourt && _vm.fayuannum[1] != 0 ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[60px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_vm._m(20), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "16px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.shixinData,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "shixinId",
      label: "失信公告ID"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sortTimeString",
      label: "立案时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "pname",
      label: "被执行人姓名"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "idcardNo",
      label: "身份证号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "age",
      label: "年龄"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sex",
      label: "性别"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "province",
      label: "省份"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "lxqk",
      label: "被执行人的履行情况"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "jtqx",
      label: "失信被执行人行为具体情形"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "yjCode",
      label: "执行依据文号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseNo",
      label: "案号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "court",
      label: "执行法院名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "yjdw",
      label: "做出执行依据单位"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "postTime",
      label: "发布时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "body",
      label: "内容概要"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "matchRatio",
      label: "匹配度",
      fixed: "right"
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), !_vm.isEnolfaxCourt && _vm.fayuannum[2] != 0 ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[60px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_vm._m(21), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "16px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.cpwsData,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "cpwsId",
      label: "裁判文书ID"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sortTimeString",
      label: "审结时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseType",
      label: "文书类型(案件类型)"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "trialProcedure",
      label: "审理程序"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "court",
      label: "法院名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "anyou",
      label: "案由编码"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseCause",
      label: "案由"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "judge",
      label: "审判员"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseNo",
      label: "案号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "judgeResult",
      label: "判决结果",
      width: "220"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "yiju",
      label: "依据",
      width: "350"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "anyouType",
      label: "案由编码类型"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "courtRank",
      label: "法院等级",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.courtRank == 1 ? _c("div", [_vm._v("最高院")]) : scope.row.courtRank == 2 ? _c("div", [_vm._v("高院")]) : scope.row.courtRank == 3 ? _c("div", [_vm._v("中院")]) : _c("div", [_vm._v("其他")])];
      }
    }], null, false, 143145002)
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "body",
      label: "内容概要",
      width: "100"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "partyId",
      label: "当事人id"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "matchRatio",
      label: "匹配度",
      fixed: "right"
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), !_vm.isEnolfaxCourt && _vm.fayuannum[3] != 0 ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[60px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_vm._m(22), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "16px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.fyggData,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "fyggId",
      label: "法院公告ID"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "pname",
      label: "姓名"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sortTimeString",
      label: "发布时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "court",
      label: "法院名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "layout",
      label: "版面"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "ggType",
      label: "公告类型"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "body",
      label: "公告内容"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "plaintiff",
      label: "原告"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "defendant",
      label: "被告"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "matchRatio",
      label: "匹配度",
      fixed: "right"
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), !_vm.isEnolfaxCourt && _vm.fayuannum[4] != 0 ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[60px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_vm._m(23), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "16px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.bgtData,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "bgtId",
      label: "曝光台ID"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "pname",
      label: "当事人"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sortTimeString",
      label: "立案时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "bgDate",
      label: "曝光日期"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "court",
      label: "法院名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "proposer",
      label: "申请人"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "idcardNo",
      label: "身份证号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseCause",
      label: "案由"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "unnexeMoney",
      label: "未执行金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.unnexeMoney) + "元\n                ")];
      }
    }], null, false, 2685679523)
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "地址"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseNo",
      label: "案号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "yiju",
      label: "依据",
      width: "200"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "execMoney",
      label: "标的金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.execMoney) + "元\n                ")];
      }
    }], null, false, 109394453)
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "body",
      label: "内容",
      width: "100"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "matchRatio",
      label: "匹配度",
      fixed: "right"
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), !_vm.isEnolfaxCourt && _vm.fayuannum[5] != 0 ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[60px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_vm._m(24), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "16px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.ktggData,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "ktggId",
      label: "开庭公告ID"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sortTimeString",
      label: "开庭时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "plaintiff",
      label: "原告"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "organizer",
      label: "组织者"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "courtroom",
      label: "法庭名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "court",
      label: "法院名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseCause",
      label: "案由"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "judge",
      label: "法官"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseNo",
      label: "案号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "defendant",
      label: "被告"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "body",
      label: "内容概要",
      width: "200"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "matchRatio",
      label: "匹配度",
      fixed: "right"
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), !_vm.isEnolfaxCourt && _vm.fayuannum[6] != 0 ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[60px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_vm._m(25), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "16px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.ajlcData,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "ajlcId",
      label: "案件流程ID"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sortTimeString",
      label: "立案时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "member",
      label: "法庭成员"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "clerkPhone",
      label: "当值员电话"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseType",
      label: "案件类别"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "trialProcedure",
      label: "审理程序"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sentencingDate",
      label: "判决日期"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseStatus",
      label: "案件状态"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "organizer",
      label: "组织者"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "filingDate",
      label: "归档日期"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "court",
      label: "法院名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "ajlcStatus",
      label: "审理状态"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "chiefJudge",
      label: "主要法官"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseCause",
      label: "案由"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "trialLimitDate",
      label: "审判限制日期"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "clerk",
      label: "书记员"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "judge",
      label: "法官"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "actionObject",
      label: "诉讼标的"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "pname",
      label: "当事人"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseNo",
      label: "案号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "effectiveDate",
      label: "有效日期"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "body",
      label: "内容",
      width: "200"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "plaintiff",
      label: "原告"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "defendant",
      label: "被告"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "matchRatio",
      label: "匹配度",
      fixed: "right"
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), !_vm.isEnolfaxCourt && _vm.fayuannum[7] != 0 ? _c("div", {
    staticClass: "report-body-content mb-[60px] mt-[60px]"
  }, [_c("div", {
    staticClass: "base-item"
  }, [_vm._m(26), _vm._v(" "), _c("div", {
    staticClass: "base-item-content"
  }, [_c("el-table", {
    staticStyle: {
      margin: "20px 0",
      "font-size": "16px",
      "padding-bottom": "20px"
    },
    attrs: {
      data: _vm.wdhmdData,
      stripe: "",
      "header-cell-style": {
        color: "#fff",
        fontWeight: "700",
        backgroundColor: "#4B77D7"
      },
      "cell-style": _vm.tableRowStyle,
      fit: "false"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "wdhmdId",
      label: "网贷黑名单ID"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sortTimeString",
      label: "贷款时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "pname",
      label: "姓名"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "idcardNo",
      label: "身份证号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "age",
      label: "年龄"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sex",
      label: "性别"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "phone",
      label: "居住电话"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "birthPlace",
      label: "籍贯地址"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "居住地址"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "email",
      label: "邮箱地址"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "mobile",
      label: "手机号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "updateTime",
      label: "信息更新时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "execCourt",
      label: "执行法院"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "whfx",
      label: "未还/罚息"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "bjbx",
      label: "本金/本息"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "caseCode",
      label: "案号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "sourceName",
      label: "来源单位名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "datasource",
      label: "数据源"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "yhje",
      label: "已还金额"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "body",
      label: "内容"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "matchRatio",
      label: "匹配度",
      fixed: "right"
    }
  })], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "report-body-item",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c("div", {
    staticClass: "report-body-title"
  }, [_c("img", {
    staticClass: "report-title-icon",
    attrs: {
      src: require("@/assets/images/report/title-icon.png"),
      alt: ""
    }
  }), _vm._v("\n        3C租赁申请意向\n        "), _vm.applyLoanSeqNo ? _c("span", {
    staticStyle: {
      "margin-left": "12px",
      "font-size": "14px",
      "font-weight": "400",
      color: "#888"
    }
  }, [_vm._v("流水号 " + _vm._s(_vm.applyLoanSeqNo))]) : _vm._e()]), _vm._v(" "), _vm.data.channel_errors && _vm.data.channel_errors.apply_loan_c ? _c("div", {
    staticStyle: {
      color: "#E6A23C",
      margin: "8px 0 16px"
    }
  }, [_vm._v("\n        3C通道异常：" + _vm._s(_vm.data.channel_errors.apply_loan_c) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.applyLoanFlagLabel ? _c("div", {
    staticStyle: {
      margin: "0 0 12px",
      color: "#626262"
    }
  }, [_vm._v("输出标识：" + _vm._s(_vm.applyLoanFlagLabel))]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "report-body-content"
  }, [_c("div", {
    staticClass: "base-item daikan-item"
  }, [_vm.applyLoanData.length > 0 ? _c("div", {
    staticClass: "base-item-content daikan-item-content"
  }, [_c("div", {
    staticClass: "common-table common-table1"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("统计类型")]), _vm._v(" "), _vm._l(_vm.applyLoanData, function (item) {
    return _c("div", {
      key: item.time,
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(item.time))]);
  })], 2), _vm._v(" "), _vm._l(_vm.tableFields, function (field) {
    return _c("div", {
      key: field.key,
      staticClass: "table-row"
    }, [_c("div", {
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), _vm._l(_vm.applyLoanData, function (item) {
      return _c("div", {
        key: "".concat(item.time, "-").concat(field.key),
        staticClass: "table-cell"
      }, [_vm._v("\n                  " + _vm._s(item[field.key]) + "\n                ")]);
    })], 2);
  })], 2), _vm._v(" "), _c("div", {
    staticClass: "mb-[20px]"
  }, [_vm._v('\n              注：取值按「身份证号命中次数/手机号命中次数」展示，如 "1/2"。时间维含近3天/7天/14天及1/3/6/12月。\n            ')])]) : _c("div", {
    staticStyle: {
      "text-align": "center",
      "padding-top": "80px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.data.channel_errors && _vm.data.channel_errors.apply_loan_c ? _vm.data.channel_errors.apply_loan_c : _vm.applyLoanFlagLabel || "未查询到可用数据") + "\n          ")])])])]), _vm._v(" "), _vm._m(27)])]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "report-body-title"
  }, [_c("img", {
    staticClass: "report-title-icon",
    attrs: {
      src: require("@/assets/images/report/title-icon.png"),
      alt: ""
    }
  }), _vm._v("\n        基础信息\n      ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "report-body-title"
  }, [_c("img", {
    staticClass: "report-title-icon",
    attrs: {
      src: require("@/assets/images/report/title-icon.png"),
      alt: ""
    }
  }), _vm._v("\n        风险名单\n      ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            申请雷达报告详情\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            行为雷达报告详情\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            近12个月逾期详情\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            近12个月履约详情\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-header"
  }, [_c("div", {
    staticClass: "table-cell"
  }, [_vm._v("统计类型")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("近1月")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("近3月")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("近6月")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("近12月")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            近12个月贷款详情\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-header"
  }, [_c("div", {
    staticClass: "table-cell",
    staticStyle: {
      "border-radius": "10px 10px 0 0"
    }
  }, [_vm._v("统计类型")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell",
    staticStyle: {
      "border-radius": "10px 0 0 0"
    }
  }, [_vm._v("近1月")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("近3月")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell"
  }, [_vm._v("近6月")]), _vm._v(" "), _c("div", {
    staticClass: "table-cell",
    staticStyle: {
      "border-radius": "0 10px 0 0"
    }
  }, [_vm._v("近12月")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            信用现状报告详情\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-icon"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/xinyong-icon1.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-label"
  }, [_c("div", [_vm._v("网络贷款机构")]), _vm._v(" "), _c("div", [_vm._v("最大授信额度")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-icon",
    staticStyle: {
      width: "66px"
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/xinyong-icon2.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-label"
  }, [_c("div", [_vm._v("网络贷款机构")]), _vm._v(" "), _c("div", [_vm._v("平均授信额度")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-icon",
    staticStyle: {
      width: "80px"
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/xinyong-icon3.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-label"
  }, [_c("div", [_vm._v("消金贷款类机构")]), _vm._v(" "), _c("div", [_vm._v("最大授信额度")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-icon"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/report/xinyong-icon4.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "info-label"
  }, [_c("div", [_vm._v("消金贷款类机构")]), _vm._v(" "), _c("div", [_vm._v("平均授信额度")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            案件时间树\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            执行公告\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            失信公告\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            判决文书\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            法院公告\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            曝光台\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            开庭公告\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            案件流程\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-item-title"
  }, [_c("img", {
    staticClass: "base-title-icon",
    attrs: {
      src: require("@/assets/images/report/subtitle-icon.png"),
      alt: ""
    }
  }), _vm._v("\n            网贷黑名单\n          ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm._v("\n      报告阅读须知\n      "), _c("div", [_vm._v("\n        1.客户使用本报告，需经过被查询人授权，客户承担因授权不充分引起的任何法律责任。")]), _vm._v(" "), _c("div", [_vm._v("\n        2.本报告仅限客户内部使用，请妥善保管本报告，不得向任何第三方泄露或允许任何第三方使用本报告。\n      ")]), _vm._v(" "), _c("div", [_vm._v("\n        3.本报告仅供客户参考，不作为客户决策的依据。\n      ")]), _vm._v(" "), _c("div", [_vm._v("\n        4.未经我司书面许可，任何人不得擅自复制、摘录、编辑、装载、披露和发表。\n      ")]), _vm._v(" "), _c("div", [_vm._v("\n        5.请确保在安全的物理及网络环境操作并确保内容的保密、安全以及合规应用。\n      ")])]);
}];
render._withStripped = true;